import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { LoginPage } from './components/LoginPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RestrictedAccessPage } from './components/RestrictedAccessPage';
import { RoleProtectedRoute } from './components/RoleProtectedRoute';
import { RootRedirect } from './components/RootRedirect';
import { ComingSoon } from './pages/ComingSoon';
import { CommunicationDetailPage } from './pages/communications/CommunicationDetailPage';
import { CommunicationsPage } from './pages/communications/CommunicationsPage';
import { EngageSetup } from './pages/engage-setup';
import { PartnerMetricsPage } from './pages/metrics/PartnerMetricsPage';
import { ApiPage } from './pages/partner-settings/ApiPage';
import { DataIntegrationPage } from './pages/partner-settings/DataIntegrationPage';
import { ProfilePage } from './pages/partner-settings/ProfilePage';
import { ThemePage } from './pages/partner-settings/ThemePage';
import { TenantDetail } from './pages/tenants/TenantDetail';
import { TenantsPage } from './pages/tenants/TenantsPage';
import { UserDetailPage } from './pages/users/UserDetailPage';
import { UsersPage } from './pages/users/UsersPage';
import { appRoutes } from './app-routes';

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Restricted access page for users without proper role */}
        <Route
          path="/restricted"
          element={
            <ProtectedRoute>
              <RestrictedAccessPage />
            </ProtectedRoute>
          }
        />

        {/* Protected routes with persistent layout and sidebar - require admin role */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <Navigate to="/dashboard/metrics" replace />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/metrics"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <Navigate to="/dashboard/metrics/engage" replace />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/metrics/:tab"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <PartnerMetricsPage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/settings"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <ProfilePage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/settings/data-integration/:tab?"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <DataIntegrationPage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/settings/theme"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <ThemePage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/settings/api"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <ApiPage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/tenants"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <TenantsPage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/tenants/:id/:tab?"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <TenantDetail />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/communications"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <CommunicationsPage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/communications/:id"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <CommunicationDetailPage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard/users"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <UsersPage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/users/:externalId"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <UserDetailPage />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path={`${appRoutes.ENGAGE_SETUP}/*`}
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <EngageSetup />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />

        {/* Generic Coming Soon route for not-yet-implemented pages */}
        <Route
          path="/dashboard/coming-soon"
          element={
            <ProtectedRoute>
              <RoleProtectedRoute allowedRoles={['admin']}>
                <Layout>
                  <ComingSoon />
                </Layout>
              </RoleProtectedRoute>
            </ProtectedRoute>
          }
        />

        {/* Default redirect - checks auth state */}
        <Route path="/" element={<RootRedirect />} />

        {/* Catch all - redirect to root for proper auth handling */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
